import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SearchTextComponent } from "./search-text/search-text.component";
import { FormsModule } from "@angular/forms";
import { MaterialModule } from "../../material/material.module";
import { HighlightSearchPipe } from "./highlight-search/highlight-search.pipe";
import { HeroIconModule } from "../../icons/heroIcon.module";

@NgModule({
  declarations: [SearchTextComponent, HighlightSearchPipe],
  imports: [CommonModule, FormsModule, MaterialModule, HeroIconModule],
  exports: [SearchTextComponent, HighlightSearchPipe],
})
export class TableAddonsModule {}
